<template>
  <div>
    <div class="title mb-3">{{ $t('tablesMap.title') }}</div>
    <div v-for="[key, sector] in Object.entries(contestCurrentStateMap)" :key="key" class="mb-4">
      <b-row class="align-middle selector">
        <b-col class="pt-2 text-center">{{ sector.Sigla }} - {{ sector.Descrizione }}</b-col>
        <b-col class="pt-2 text-right">{{ $t('filters.round') }}</b-col>
        <b-col><combo-or-label v-model="selectedRoundByKey[key]" :options="Object.keys(sector.Rounds)"></combo-or-label></b-col>
      </b-row>

      <b-table :fields="fieldsToBeShown" :items="getTablesFrom(sector, selectedRoundByKey[key])" sort-by="round" class="figbHeader mt-3">
        <template #cell(NsEventId)="data">
          <span v-html="data.value"></span>
        </template>
        <template #cell(EwEventId)="data">
          <span v-html="data.value"></span>
        </template>
        <template #cell(N)="data">
          <span v-html="data.value"></span>
        </template>
        <template #cell(S)="data">
          <span v-html="data.value"></span>
        </template>
        <template #cell(E)="data">
          <span v-html="data.value"></span>
        </template>
        <template #cell(W)="data">
          <span v-html="data.value"></span>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import ComboOrLabel from "../components/lib/ComboOrLabel";
import individualContest from "../mixins/individualContest";

export default {
  name: 'TablesMap',
  mixins: [individualContest],
  components: {ComboOrLabel},
  data() {
    return {
      selectedRoundByKey: {}
    }
  },
  methods: {
    getTablesFrom(sector, round) {
      return Object.entries(sector.Rounds[round]?.Tables ?? {})
          .map(el => {
            const [tableNumber, table] = el;
            return {
              TableNumber: tableNumber,
              ...table
            }
      })
    },
  },
  computed: {
    ...mapGetters({
      contestCurrentStateMap: 'tournament/contestCurrentStateMap',
      pairs: 'players/pairsList'
    }),
    fieldsToBeShown() {
      const that = this;
      const baseFields = [
        {
          key: 'TableNumber',
          label: this.$t('tablesMap.tableAbbr')
        },
        {
          key: 'Boards',
          label: this.$t('tablesMap.boardsLabel'),
          formatter: value => {

            if (value.length === 0) {
              return "";
            }

            if (value.length === 1) {
              return value[0];
            }

            const ordered = [...value].map(n => Number.parseInt(n)).sort((n1, n2) => n1 - n2);

            for (let i = 1; i < ordered.length; i++) {
              if (ordered[i] !== ordered[i - 1] + 1) {
                //Not ordered board numbers, return'em all
                return ordered.join(', ');
              }
            }

            //Ordered board numbers, return first-last
            return ordered[0] + "-" + ordered[ordered.length - 1];
          }
        }
      ];

      if (that.isIndividual) {
        return [...baseFields,
          { key: 'N', label: 'N', formatter: val => that.playersByCode[val]?.Name ?? val },
          { key: 'S', label: 'S', formatter: val => that.playersByCode[val]?.Name ?? val },
          { key: 'E', label: 'E', formatter: val => that.playersByCode[val]?.Name ?? val },
          { key: 'W', label: 'W', formatter: val => that.playersByCode[val]?.Name ?? val }
        ];
      }

      return [...baseFields,
        {
          key: 'NsEventId',
          label: "NS",
          formatter: val => that.pairs[val].Name.replace(" - ", "<br>")
        },
        {
          key: 'EwEventId',
          label: "EW",
          formatter: val => that.pairs[val].Name.replace(" - ", "<br>")
        }
      ];
    }
  },
  mounted() {
    const temp = {}
    Object.entries(this.contestCurrentStateMap).forEach(([key, sector]) => {
      temp[key] = Math.min(sector.CurrentRound, Math.max(...Object.keys(sector.Rounds)))
    });
    this.selectedRoundByKey = temp;
  }
};
</script>

<style scoped>
>>> .figbHeader thead {
  color: #1e3a5f !important;
  background-color: #eef2f7 !important;
}

.title {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  font-size: 1.2rem;
  font-weight: 700;
  color: #1e3a5f;
  letter-spacing: -0.01em;
}
</style>
